/* eslint-disable */
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as help from '@bingads-webui-component-legacy/help/index';
import tmpl from '@bingads-webui-campaign-legacy/crud-keywords/template/create.pug';
import * as _KeywordViewModel from '@bingads-webui-campaign-legacy/crud-keywords/viewmodel/keyword';
import parserViewModel from '@bingads-webui-campaign-legacy/crud-keywords/viewmodel/parser';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import pageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var s$TextAd = window.globalLegacySchema.get('TextAd');
var notEnoughText = '20000';
var tooMuchText = '20001';
var defaultPopupIds = {
  'EnterKeywords': 'pop_BA_CampaignCreate_Keywords_EnterKeywords'
};
var defaultScenario = 'create keyword';
var KeywordViewModel = _KeywordViewModel.ViewModel;
var parseKeyword = _KeywordViewModel.parseKeyword;
var View = Backbone.View.extend({
  events: {
    'keyup textarea.form-control': 'getSeedKeywords',
    'paste textarea.form-control': 'getSeedKeywords',
    'change textarea.form-control': 'keywordsChanged',
    'click .keyword-textarea': 'selectThisAdGroup',
    'focusout textarea.keyword-textarea.form-control': 'outTextArea'
  },
  initialize: function (options) {
    var self = this;
    self.options = _.defaults({}, options, {
      scenario: defaultScenario
    });
    self.isNegativeKeyword = options.isNegativeKeyword;
    self.popupIds = _.defaults({}, self.options.popupIds, defaultPopupIds);
    self.isBmmBlockEnabled = pageContext.DynamicPermissions && pageContext.DynamicPermissions.KeywordBmmSignupP2 || pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.KeywordBmmPhase2;
    self.isBmmWarningEnabled = self.isBmmBlockEnabled ? false : pageContext.DynamicPermissions && pageContext.DynamicPermissions.KeywordBmmAlert || pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.KeywordBmmWarning;
    self.isMutableKeywordMatchTypeEnabled = self.isBmmBlockEnabled || self.isBmmWarningEnabled ? false : pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.BMMBehaviorUpdate;
    self.keywords = ko.observable({});
    self.parser = new parserViewModel(options.isNegativeKeyword, self.isBmmBlockEnabled);
    self.hasChanges = true;
    self.parser.keywordsTextareaVal.subscribe(function (value) {
      self.hasChanges = true;
    });
    self.keywordSuggestionsAdded = [];
  },
  render: function () {
    this.$el.html(tmpl({
      appendLearnMoreLink: help.appendLearnMoreLink,
      i18n: i18n,
      uuid: uuid,
      popupIds: this.popupIds,
      isNegativeKeyword: this.isNegativeKeyword,
      isForVNext: this.options.isForVNext
    }));
    ko.applyBindings(this.parser, this.el);
    return this;
  },
  getKeys: function () {
    return _.keys(this.keywords());
  },
  getKeywords: function () {
    return _.values(this.keywords());
  },
  isEmpty: function () {
    return _.size(this.parser.keywordsTextareaVal()) === 0;
  },
  isBmmExist: function () {
    var keywords = this.parser.peekKeywords();
    return this.parser.isBmmExist(keywords);
  },
  isBmmWarning: function () {
    return this.isBmmWarningEnabled && this.isBmmExist();
  },
  isMutableKeywordMatchTypeWarning: function () {
    return this.isMutableKeywordMatchTypeEnabled && this.isBmmExist();
  },
  isBmmBlock: function () {
    return this.isBmmBlockEnabled && this.isBmmExist();
  },
  logInteraction: function (message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, this.options.scenario);
    }
  },
  validate: function () {
    this.parser.isAfterFirstInteraction(true);
    var isValid = this.parser.validate();
    if (!isValid) {
      this.logInteraction('keyword is not valid');
    }
    return isValid;
  },
  selectThisAdGroup: function () {
    this.trigger('keywords:selected');
  },
  getSeedKeywords: function (e) {
    this.parser.showBmmWarningAlert(this.isBmmWarning());
    this.parser.showBmmBlockAlert(this.isBmmBlock());
    this.parser.showMutableKeywordMatchTypAlert(this.isMutableKeywordMatchTypeWarning());
    var self = this;
    if (_.size(self.parser.seedKeywords()) >= self.parser.numSeedKeywords) {
      return;
    }
    this.trigger('keywords:updated');
    if (e.keyCode === 13 || e.keyCode === 188 || e.type === 'paste') {
      if (!self.parser.seedKeywords()) {
        self.parser.seedKeywords([]);
        setTimeout(function () {
          if (_.size(self.parser.seedKeywords()) > 0) {
            self.trigger('seedKeywordsEntered', self.parser.seedKeywords());
          }
        }, self.parser.seedKeywordTimeout);
      }
      setTimeout(function () {
        var keywords = self.parser.peekKeywords();
        if (keywords.length > 0) {
          var endIndex = Math.min(keywords.length, self.parser.numSeedKeywords);
          self.parser.seedKeywords(keywords.slice(0, endIndex));
        }
      }, 5);
    }
    self.parser.parseKeywords();
  },
  keywordsChanged: function () {
    this.logInteraction('keywords change');
  },
  outTextArea: function (e) {
    this.parser.parseKeywords();
    this.trigger('keywords:outTextArea');
  },
  addSuggestion: function (addedKeywords, sourceReqId) {
    var newKeywords = _.difference(addedKeywords, this.parser.parsedKeywords());
    if (newKeywords.length === 0) {
      return;
    }
    this.keywordSuggestionsAdded = this.keywordSuggestionsAdded.concat(_.map(newKeywords, function (newKeyword) {
      return {
        keyword: newKeyword,
        sourceReqId: sourceReqId
      };
    }));
    var textareaValue = this.parser.keywordsTextareaVal();
    textareaValue = textareaValue.replace(/([,\s]+$)/g, '');
    var added = newKeywords.join('\n');
    if (_.size(textareaValue) === 0) {
      textareaValue = added;
    } else {
      textareaValue = textareaValue + '\n' + added;
    }
    this.parser.keywordsTextareaVal(textareaValue);
    this.parser.isAfterFirstInteraction(true);
    this.parser.parseKeywords();
    this.hasChanges = true;
    this.trigger('keywords:addSuggestion');
  },
  getContextObjects: function () {
    return _.map(this.getKeywords(), function (keyword, index) {
      return {
        Id: keyword.Id(),
        Text: keyword.Text(),
        MatchType: keyword.MatchType()
      };
    });
  },
  getKeyFromKeyword: function (keyword) {
    switch (keyword.MatchType) {
      case 'Broad':
        return keyword.Text;
      case 'Phrase':
        return '"' + keyword.Text + '"';
      case 'Exact':
        return '[' + keyword.Text + ']';
    }
    return null;
  },
  getChangedKeywords: function (adGroup) {
    if (!this.hasChanges) {
      return [];
    }
    var oldKeywords = this.getKeys();
    var newKeywords = this.parser.uniqueParsedKeywords();
    var changedKeywords = _.union(this.serializeToCreate(_.difference(newKeywords, oldKeywords), adGroup), this.serializeToDelete(_.difference(oldKeywords, newKeywords)));
    return changedKeywords;
  },
  getCurKeywords: function () {
    var newKeywords = this.parser.uniqueParsedKeywords();
    return _.map(newKeywords, function (keyword) {
      return parseKeyword(keyword);
    });
  },
  serializeToCreate: function (toCreate, adGroup) {
    var self = this;
    var serializedKeywords = [];
    if (toCreate.length > 0) {
      var options = _.extend({}, self.options, {
        'adGroup': adGroup
      });
      _.each(toCreate, function (keyword, index) {
        options.text = keyword;
        var serializedKeyword = new KeywordViewModel(options).toObject();
        serializedKeywords[index] = _.isNaN(adGroup.Id) || adGroup.Id < 1 ? _.pick(serializedKeyword, 'Text', 'MatchType', 'AdGroupName', 'CampaignName', 'Bid') : _.pick(serializedKeyword, 'Text', 'MatchType', 'AdGroup', 'Bid');
      });
    }
    return serializedKeywords;
  },
  serializeToDelete: function (toDelete) {
    var serializedKeywords = [];
    if (toDelete.length > 0) {
      var self = this;
      _.each(toDelete, function (keyword, index) {
        var serializedKeyword = self.keywords()[keyword].toObject();
        serializedKeyword.Status = 'Deleted';
        serializedKeywords[index] = _.pick(serializedKeyword, 'Id', 'AdGroup', 'Status', 'Text', 'MatchType');
      });
    }
    return serializedKeywords;
  },
  getNameAndLengthForProperty: function (property) {
    return {
      name: i18n.get('ColumnName_' + property),
      length: s$TextAd.properties[property].maxLength
    };
  },
  addErrors: function (errors) {
    self.parser.errors.add(i18nErrors.getODataErrors(errors));
  },
  escapeHtml: function (text) {
    return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  },
  handleApiErrors: function (keywords) {
    var self = this;
    var errors = [];
    _.each(keywords, function (keyword) {
      _.each(keyword.errors, function (err) {
        var errorFromAd = _.contains(['Title', 'Text', 'DestinationUrl'], err.property);
        if (errorFromAd && err.code === tooMuchText && err.message.indexOf('{0}') > -1 && err.message.indexOf('{1}') > -1) {
          var pairs = self.getNameAndLengthForProperty(err.property);
          err.message = err.message.replace('{0}', pairs.name).replace('{1}', pairs.length);
        }
        if (errorFromAd && err.code === notEnoughText && err.message.indexOf('{0}') > -1) {
          err.message = err.message.replace('{0}', self.getNameAndLengthForProperty(err.property).name);
        }
        err.message = i18n.getString('Keywords_And_Errors_seperator', self.escapeHtml(self.getKeyFromKeyword(keyword)), err.message);
        errors.push(err);
      });
    });
    self.parser.errors.add(errors);
  },
  clearErrors: function () {
    this.parser.errors.clear(i18nErrors.isCampaignApiError);
  },
  updateViewModels: function (input) {
    var keywords = input.keywords;
    var campaignId = input.campaignId;
    var adGroupId = input.adGroupId;
    var hasErrors = input.hasErrors;
    this.clearErrors();
    var successfulKeywords = [];
    var keywordsWithErrors = [];
    if (hasErrors) {
      _.each(keywords, function (keyword) {
        if (keyword.errors && !keyword.Id) {
          keywordsWithErrors.push(keyword);
        } else {
          successfulKeywords.push(keyword);
        }
      });
    } else {
      successfulKeywords = keywords;
    }
    if (!_.isEmpty(keywordsWithErrors)) {
      this.handleApiErrors(keywordsWithErrors);
    }
    if (successfulKeywords.length === keywords.length) {
      this.hasChanges = false;
    }
    var newlyCreatedKeywords = [];
    _.each(successfulKeywords, (function (keyword) {
      var key = this.getKeyFromKeyword(keyword);
      if (keyword.Status === 'Deleted') {
        delete this.keywords()[key];
      } else {
        this.keywords()[key] = new KeywordViewModel({
          properties: keyword
        });
        newlyCreatedKeywords.push(keyword.Text);
      }
    }).bind(this));
    var numberOfCreatedKeywords = _.size(newlyCreatedKeywords);
    if (numberOfCreatedKeywords > 0) {
      var keywordsImportedFromPlanner = _.filter(this.keywordSuggestionsAdded, function (suggestedKeyword) {
        return _.indexOf(newlyCreatedKeywords, suggestedKeyword.keyword) !== -1;
      });
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createKeyword/updateViewModels', JSON.stringify({
        keywordsCreated: numberOfCreatedKeywords,
        campaignId: campaignId,
        adGroupId: adGroupId,
        suggestionsUsed: _.size(keywordsImportedFromPlanner),
        detailedSuggestionsUsed: _.chain(keywordsImportedFromPlanner).groupBy(function (keyword) {
          return keyword.sourceReqId;
        }).mapObject(function (reqGroup) {
          return _.pluck(reqGroup, 'keyword');
        }).value()
      }));
      this.keywordSuggestionsAdded = [];
    }
    return this.getContextObjects();
  }
});
export default View;

